<div class="flex min-w-0 gap-2">
  @if (useNewAvatarStyle()) {
    <div
      data-placeholder="False"
      data-size="sm"
      data-state="Default"
      data-status-icon="False"
      data-text="True"
      class="relative mt-1 size-8 shrink-0 rounded-[200px] bg-indigo-50"
    >
      <div
        class="absolute left-0 top-[6px] w-8 justify-start text-center text-sm font-medium leading-5 text-blue-600"
      >
        {{ generateInitials() }}
      </div>
    </div>
  } @else if (menu(); as menu) {
    <button
      type="button"
      class="h-fit cursor-pointer rounded-full"
      [matMenuTriggerFor]="menu"
    >
      <app-avatar
        [initials]="generateInitials()"
        [highlightCircle]="hasHighlightCircle()"
      ></app-avatar>
    </button>
  } @else {
    <app-avatar
      [initials]="generateInitials()"
      [highlightCircle]="hasHighlightCircle()"
    ></app-avatar>
  }
  <div class="min-w-0 flex-1">
    <div
      data-hj-suppress
      class="flex items-center truncate text-sm text-primary"
      [ngClass]="{ 'font-semibold': highlightUsername() }"
    >
      <span class="truncate">{{ username() }}</span>
      @if (isCurrentUser()) {
        <div
          class="ml-2 inline-flex h-4 items-center justify-center gap-2 rounded-md bg-grey-lightGrey px-[5px] py-1 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]"
        >
          <span class="text-dark-grey text-[10px] font-semibold leading-3">{{
            'general.currentUser' | transloco
          }}</span>
        </div>
      }
    </div>
    <div class="flex min-w-0 items-center gap-1">
      @if (isHRISEnabled() && syncStatus(); as syncStatus) {
        <app-user-sync-status-icon [syncStatus]="syncStatus" />
      }
      <span
        [ngClass]="allowEmailWrap() ? 'break-all' : 'truncate'"
        class="text-sm font-normal text-grey"
      >
        {{ email() }}
      </span>
    </div>
  </div>
</div>
